//股吧通用文字处理模块

	var text = {
		titleclean : function (txt){ //清除标题的非法字符
			if( $.trim(txt) == "" ){
				return "";
			}
			var re = /[☆★●◎◆■▲〓◢█◣▌◥◤▓※⊙☂▆【】✪▉▊▋▌︻▏▎▍☀▅❤　]/g;
			return txt.replace(re,"");
		},
		TxtLeft: function (txt, n) {
			if( txt == null || txt == "" ){
				return "";
			}
			var thislength = 0;
			for (var i = 0; i < txt.length; i++) {
				if (txt.charCodeAt(i) > 255) {
					thislength += 2;
				}
				else {
					thislength++;
				}
				//console.info(thislength);
				if (thislength > n) {
					return txt.substring(0, i) + "...";
					break;
				}
			}
			return txt;
		},
		TxtLeftNoDot: function (txt, n) {
			if( txt == null || txt == "" ){
				return "";
			}
			var thislength = 0;
			for (var i = 0; i < txt.length; i++) {
				if (txt.charCodeAt(i) > 255) {
					thislength += 2;
				}
				else {
					thislength++;
				}
				//console.info(thislength);
				if (thislength > n) {
					return txt.substring(0, i);
					break;
				}
			}
			return txt;
		},
		TxtLeftta: function (txt, n, fill) {//指定长度截取字符串
			var thislength = 0;
			for (var i = 0; i < txt.length; i++) {
				if (txt.charCodeAt(i) > 255) {
					thislength += 2;
				}
				else {
					thislength++;
				}
				if (thislength > n) {
					if(fill){
						return txt.substring(0, i) + fill;
					}else{
						return txt.substring(0, i) + "...";
					}
					break;
				}
			}
			return txt;
		},
		TxtLength: function (txt) {
			var thislength = 0;
			for (var i = 0; i < txt.length; i++) {
				if (txt.charCodeAt(i) > 255) {
					thislength += 2;
				}
				else {
					thislength++;
				}
			}
			return thislength;
		},
		numshow: function (num) {
			if (num == 0) return "";
			return "(" + num.toString() + ")";
		},
		smallimg : function (url){
			if( url == null || url == "" ){
				return ""
			}
			if( url.match(/\d{8}/) == null ){
				return "";
			}
			var position = url.match(/\d{8}/).index;
			return url.substring(0,position + 8) + "/size100" + url.substring(position + 8,url.length);
		},
		atlength : function (text){ //有多少个@某人
			var temp = text.match(/@\S+(\s|$)/g);
			if( temp == null ){
				return 0;
			}
			return temp.length;
		},
		isstock:function (code){ //简单判断是否是股票号码
			if( /\d{6}/.test(code)){
				code = code.toString();
				if( code.substring(0,1) == "4" ){ //三板
					return false;
				}
				else if ("100,101,108,109,111,112,115,119,125,126,129,131,010,019,020,130,110,113,104,105,106,107,201,202,203,204".indexOf(code.substring(0, 3)) > -1 || "75,12".indexOf(code.substring(0, 2)) > -1){ //债券
					return false;
				}
				else{
					return true;
				}
			}
			else{
				return false;
			}
		},
		isallstock:function (code){ //简单判断是否是股票号码 包括美股和港股
			code = code.toString();
			if( code.substring(0,2) == "hk" || code.substring(0,2) == "us" ){
				return true;
			}
			if( /\d{6}/.test(code)){
				code = code.toString();
				if( code.substring(0,1) == "4" ){ //三板
					return false;
				}
				else if ("100,101,108,109,111,112,115,119,125,126,129,131,010,019,020,130,110,113,104,105,106,107,201,202,203,204".indexOf(code.substring(0, 3)) > -1 || "75,12".indexOf(code.substring(0, 2)) > -1){ //债券
					return false;
				}
				else{
					return true;
				}
			}
			else{
				return false;
			}
		},
		clearhtml :function (text){
			return text.replace(/<[^>]*?>/ig, '');
		},
		gettime :function (){ //获得当前时间 例子 2021-04-03 23:12:52
			var temptime = new Date();
			var month = (temptime.getMonth() + 1).toString();
			month = month.length == 1?"0" + month:month;
			var day = temptime.getDate().toString();
			day = day.length == 1?"0" + day:day;
			return temptime.getFullYear() + '-' + month + '-' + day + ' ' + temptime.getHours() + ':' + temptime.getMinutes() + ":" + temptime.getMinutes();
		},
		getshorttime :function (){ //获得当前时间 例子 2021-04-03
			var temptime = new Date();
			var month = (temptime.getMonth() + 1).toString();
			month = month.length == 1?"0" + month:month;
			var day = temptime.getDate().toString();
			day = day.length == 1?"0" + day:day;
			return temptime.getFullYear() + '-' + month + '-' + day;
		},
		replyadd : function (text){ //评论数字加1
			var num = 0;
			var linktext = "";
			if( text.indexOf("(") > 0 ){
				linktext = text.substring(0,text.indexOf("("));
				num = parseInt(text.substring(text.indexOf("(") + 1,text.indexOf(")")));
				num ++
				return linktext + "(" + num.toString() + ")";
			}
			else{
				return text + "(1)";
			}
		},
		cleartext : function (text){
			text = text.replace(/<br>/g," ");
			return text;
		},
		clearquot : function (text){ //转换引号
			text = text.replace(/\'/g,"\\\'");
			text = text.replace(/\"/g,"\\\"");
			return text;
		},
		arraychaos : function (arr){ //数组乱序
			if( arr.length == 0 ){
				return arr;
			}
			arr.sort(function(a,b){ return Math.random()>.5 ? -1 : 1;});
			return arr;
		},
		getmarketcode: function ( code ) {
			var sh_or_sz = "1";
			var i = code.substring(0, 1);
			var j = code.substring(0, 3);
			if (i == "5" || i == "6" || i == "9"){
				//上证股票
			}
			else{
				if (code == "000003" || code == "000300"){
					//上证股票
				}
				if (j == "009" || j == "126" || j == "110"){
					//上证股票
				}
				else{
					sh_or_sz = "2";//深圳股票
				}
			}
			return code + sh_or_sz;
		},
		gecodetmarket: function ( code ) {
			var sh_or_sz = "1";
			var i = code.substring(0, 1);
			var j = code.substring(0, 3);
			if (i == "5" || i == "6" || i == "9"){
				//上证股票
			}
			else{
				if (code == "000003" || code == "000300"){
					//上证股票
				}
				if (j == "009" || j == "126" || j == "110"){
					//上证股票
				}
				else{
					sh_or_sz = "2";//深圳股票
				}
			}
			return sh_or_sz;
		},
		showface : function (html) {
			html = this.showstockcode(html);
			var facearr = ["微笑","大笑","鼓掌","不说了","为什么","哭","不屑","怒","滴汗","拜神","胜利","亏大了","赚大了","牛","俏皮","傲","好困惑","兴奋","赞","不赞","摊手","好逊","失望","加油","困顿","想一下","围观","献花","大便","爱心","心碎","毛估估","成交","财力","护城河","复盘","买入","卖出","满仓","空仓","抄底","看多","看空","加仓","减仓"];
			var re = new RegExp('\\[.+?\\]', "ig");
			html = html.replace(re, function (item) {
					for (var i = 0; i < facearr.length; i++){
						if( "[" + facearr[i] + "]" == item ){
							if( i < 9 ){
								return '<img title="' + facearr[i] + '" src="https://gbres.dfcfw.com/face/emot/emot0' + (i + 1) + '.png" alt="' + item + '">';
							}
							else{
								return '<img title="' + facearr[i] + '" src="https://gbres.dfcfw.com/face/emot/emot' + (i + 1) + '.png" alt="' + item + '">';
							}
							break;
						}
					}
					return item;
				});

			return html;
		},
		showstockcode : function (html){ //把 $复星国际(00656.HK)$ 转换成链接
			return html;
			// var re = new RegExp('\\$[^\\$]+?\\)\\$', "ig");
			// html = html.replace(re, function (item) {
			// 		var link = "";
			// 		var sc = item.substring(item.indexOf('.') + 1, item.indexOf(')'));
			// 		var code = item.substring(item.indexOf('(') + 1, item.indexOf('.'));
			// 		switch (sc){
			// 			case "SH":
			// 				link = 'http://guba.eastmoney.com/list,' + code + '.html';
			// 				break;
			// 			case "SZ":
			// 				link = 'http://guba.eastmoney.com/list,' + code + '.html';
			// 				break;
			// 			case "US":
			// 				link = 'http://guba.eastmoney.com/list,us' + code + '.html';
			// 				break;
			// 			case "HK":
			// 				link = 'http://guba.eastmoney.com/list,hk' + code + '.html';
			// 				break;
			// 			case "ZS":
			// 				link = 'http://quote.eastmoney.com/zs' + code + '.html';
			// 				break;
			// 			case "B":
			// 				link = 'http://guba.eastmoney.com/list,' + code + '.html';
			// 				break;
			// 			case "KJ":
			// 				link = 'http://jijinba.eastmoney.com/list,' + code + '.html';
			// 				break;
			// 			default:

			// 				break;
			// 		}
			// 		return '<a href="' + link + '" target="_blank">' + item + '</a>'
			// 		return item;
			// 	});

			// return html;
		},
		changestockcode : function (){
			$(".stockcodec").each(function (){
				if( $(this).data("sc") == "ok" ){
					return false;
				}
				var html = $(this).html();
				//console.info(html);
				var html2 = text.showstockcode(html);

				if( html != html2 ){
					$(this).html(html2);
				}
				$(this).data("sc","ok");
			});
		},
		hkcode2followcode : function (code){ //港股代码转化为加关注所用的代码 例如 hk00001 转成 hk_00001
			return code.substring(0,2) + '_' + code.substring(2);
		},
		hkquotecode2followcode : function (code){ //港股代码转化为加关注所用的代码 例如 hk00001 转成 hk_00001
			return 'hk_' + code.substring(0,5);
		},
		uscode2followcode : function (code){ //港股代码转化为加关注所用的代码 例如 a.nyse 转成 nyse_a
			return code.substring(code.indexOf('.') + 1) + '_' + code.substring(0,code.indexOf('.'));
		},
		usoutcode2followcode : function (code){ //港股代码转化为加关注所用的代码 例如 a.nyse 转成 nyse_a
			return code.substring(code.indexOf('.') + 1) + '_' + code.substring(0,code.indexOf('.'));
		},
		isuid : function (uid){
			if( uid == undefined || uid == "" ){
				return false;
			}
			if( isNaN(uid) ){
				return false;
			}
			var re = new RegExp("^[0-9]{16}$");
			if( re.test(uid) ){
				return true;
			}
			else{
				return false;
			}
		},
		stocknumf : function (text, haspercent){
			if( text == "" ){
				return "";
			}
			var txt = text;
			if( haspercent ){
				txt = text.replace("%","");
			}
			if( isNaN(txt) ){
				return text;
			}
			var num = parseFloat(txt);
			if( num > 0 ){
				return '<span class="red">↑' + text + '</span>';
			}
			else if( num < 0 ){
				return '<span class="green">↓' + text + '</span>';
			}
			else{
				return '<span>↓' + text + '</span>';
			}
		},
		filltext : function (text, length){ //填充汉字 直到规定的长度
			if( text == "" ){
				return "";
			}
			if( this.TxtLength(text) >= length ){
				return text;
			}
			var fill = "";
			for ( var i = 0; i < ( length - this.TxtLength(text) ); i++ ){
				fill += "&nbsp;";
			}
			return text + fill;
		},
		filltextback : function (text, length){ //填充汉字 直到规定的长度 给出末尾的字符

			if( this.TxtLength(text) >= length ){
				return "";
			}
			var fill = "";
			for ( var i = 0; i < ( length - this.TxtLength(text) ); i++ ){
				fill += "&ensp;"; // 
			}
			return fill;
		},
		textContain: function(txt1, txt2){
			if( txt1.indexOf(txt2) >= 0 ){
				return true;
			}
			else{
				return false;
			}
		},
		stockColor : function (num){
			if( num == NaN || num == "-" ){
				return '-';
			}
			if( num > 0 ){
				return '<span class="stockprice_up">' + num + '%</span>';
			}
			else if(num < 0){
				return '<span class="stockprice_down">' + num + '%</span>';
			}
			else{
				return '<span class="stockprice_stay">' + num + '%</span>';
			}
		},
		ratetext : function (num){ //评级星星
			if( num == '' ){
				return '暂无评级';
			}
			var temp = [];
			for ( var i = 0; i < num; i++ ){
				temp.push('★');
			}
			return temp.join('');
		},
		zdcolor : function (num, addtext){
			if( typeof num == "undefined" || num == "" || num == "-"  ){
				return "-";
			}
			if( num == NaN ){
				return '-';
			}
			if( typeof addtext == "undefined" ){
				addtext = "";
			}
			var num2 = num;
			if( num2.indexOf('%') > 0 ){
				num2.repace('%','');
			}
			if( num2 > 0 ){
				return '<span class="red">' + num + addtext + '</span>';
			}
			else if(num2 < 0){
				return '<span class="green">' + num + addtext + '</span>';
			}
			else{
				return  num + addtext ;
			}
		},
		formatStars:function(num){
	    var score = (num*1)/2;
	    var scoreInt = Math.floor(score);
	    var scoreFloat = score-scoreInt;
	    if(scoreFloat>0){
	      return scoreInt+"5";
	    }else{
	      return scoreInt;
	    }
		},
		formatTime:function(time){
			time = time.substring(0,16);
			var myDate = new Date();
			if(time.substring(0,4)==myDate.getFullYear()){
				  time = time.substring(5);
					if(time.substring(0,2)==(myDate.getMonth()+1) && time.substring(3,5)==myDate.getDate()){
			      time = "今天 "+ time.substring(6);
			    }
			}
			return time;
		},
		addZero: function(m){
            if(m < 10 && m >=0) {
                m = '0'+m;
            }
            return m;
        },
        GetQueryString: function(name) {
		    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		    var r = window.location.search.substr(1).match(reg);
		    if(r!=null)return  unescape(r[2]); return null;
		},
		formatNum:function(num){
			if(num>100000000){
				if(num>=100000000000){
					return (num/100000000).toFixed(0)+"亿";
				}else{
					return (num/100000000).toFixed(1)+"亿";
				}
			}
			if(num>10000){
				if(num>=10000000){
					return (num/10000).toFixed(0)+"万";
				}else{
					return (num/10000).toFixed(1)+"万";
				}
			}
			return num;
		},
		uniqueArr:function(arr){   //数组去重
			// var res = [];         // 安卓5.0不能用
			// res = arr && arr.filter(function(item){
			// 	return res.includes(item) ? '' : res.push(item);
			// });
			// return res;
			if(!arr){
				return ;
			}
			var res = [];
			for(var i=0; i<arr.length; i++){
				if(res.indexOf(arr[i]) == -1){
				res.push(arr[i]);
				}
			}
			return res;
		},
		getEmojiArr:function(id){
			return text.uniqueArr(document.getElementById(id).innerText.match(/\[(.+?)\]/g))?text.uniqueArr(document.getElementById(id).innerText.match(/\[(.+?)\]/g)):[];
		}
	};

	module.exports = text;



//////////////////
// WEBPACK FOOTER
// ./src/module/helper/text.js
// module id = 13
// module chunks = 0